import { toRem } from "../../helpers/theme";

const style = ({ theme, shareOpen, position }) => ({
    display: "inline-flex",
    verticalAlign: "middle",
    zIndex: theme.zIndex.over,
    ...(position === "topRightHero" && {
        position: "absolute",
        top: toRem(20),
        right: toRem(20),
        [theme.breakpoints.up("lg")]: {
            top: theme.global.baseLayout.desktop.topBar.spacing,
            right: theme.global.baseLayout.desktop.topBar.spacing,
        },
    }),
    "& .share": {
        "&_inner": {
            display: "inline-flex",
            flexDirection: "column",
            position: "relative",
        },
        "&_cta": {
            "&Btn": {
                fontSize: toRem(16),
                height: toRem(50),
                minWidth: toRem(50),
                ...(shareOpen && {
                    pointerEvents: "none",
                }),
                svg: {
                    path: {
                        fill: theme.colors.share.cta.icon,
                    },
                },
            },
        },
        "&_buttons": {
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: theme.zIndex.over,
            overflow: "hidden",
            "&List": {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flexWrap: "nowrap",
                background: theme.colors.share.buttons.background,
                padding: toRem(6),
                borderStyle: "solid",
                borderWidth: toRem(2),
                borderColor: theme.colors.share.buttons.border,
                borderRadius: toRem(100),
                overflow: "hidden",
                "& li": {
                    display: "flex",
                    flexDirection: "column",
                    marginRight: toRem(10),
                    "&:last-of-type": {
                        marginRight: 0,
                    },
                },
            },
        },
        "&_closeBtn": {
            width: toRem(34),
            height: toRem(34),
        },
    },
});

export default style;

const motionVariants = () => {
    const transition = {
        duration: 0.25,
        ease: [0.04, 0.62, 0.23, 0.98],
    };
    return {
        open: {
            opacity: 1,
            width: "auto",
            transition,
            visibility: "visible",
        },
        closed: {
            opacity: 0,
            transition,
            transitionEnd: {
                width: toRem(0),
                visibility: "hidden",
            },
        },
        visibleCta: {
            transition,
            opacity: 1,
            visibility: "visible",
        },
        hiddenCta: {
            transition,
            opacity: 0,
            transitionEnd: {
                visibility: "hidden",
            },
        },
    };
};

export { motionVariants };
